import { getLogger } from "@core/logging/logger";
import { AuthService } from "@domain/authentication/auth-service";
import { UsernameExistsCodeError } from "@domain/authentication/authentication-errors";
import { InfraManager } from "@domain/infra/infra-manager";
import { CreateFastTrackPtInput } from "@domain/register/register-fast-track/fast-track-register";
import { FastTrackRegisterService } from "@domain/register/register-fast-track/fast-track-register-service";

import { VeevaService } from "@domain/veeva/veeva-service";

export class FastTrackRegisterManager {
	private readonly logger = getLogger("🏃 [FastTrackRegisterManager]");

	constructor(
		private readonly fastTrackRegisterService: FastTrackRegisterService,
		private readonly veevaService: VeevaService,
		private readonly authService: AuthService,
		private readonly infraManager: InfraManager,
	) {}

	async registerFastTrackUser(ptInput: CreateFastTrackPtInput): Promise<void> {
		await this.infraManager.changeInfrastructureUsingCountryCode(ptInput.countryCode);
		this.logger.debug("Try to fast track with email", ptInput.email);
		const emailAlreadyExists = !(await this.authService.isEmailAvailable(ptInput.email));
		if (emailAlreadyExists) {
			this.logger.error("Email already used");
			throw new UsernameExistsCodeError();
		}
		await this.fastTrackRegisterService.registerFastTrackUser(ptInput);
		this.logger.debug("User has been signed up with fast track");
	}

	async hasVeevaRecord(email: string, countryCode: string): Promise<boolean> {
		const hasRecord = await this.veevaService.hasVeevaRecord({ email, countryCode });
		this.logger.debug("Does User have a veeva record ? ", hasRecord);
		return hasRecord;
	}
}
